import React, { useEffect } from "react";

import { Row, Col } from "react-bootstrap";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";
import {
  LedgerMasterAC,
  MasterACFun,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Master_Ac({ masterAccountList }) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { LedgerMasterACdata } = useSelector((state) => state.LedgerSlice);

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");

  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  useEffect(() => {
    if (!masterAccountList || masterAccountList.length === 0) return;

    dispatch(MasterACFun());

    dispatch(
      LedgerMasterAC({
        Firm,
        Year: FinancialYear,
        AcIDs: masterAccountList,
      }),
    );
  }, [masterAccountList, FinancialYear, Firm, dispatch]);

  if (masterAccountList.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          fontSize: "20px",
          color:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour10,
        }}
      >
        Please Select Accounts Name
      </div>
    );
  }
  if (LedgerMasterACdata === "no" || LedgerMasterACdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  const formatDateToDDMMYYYY = (isoString) => {
    if (!isoString) return "";
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getRows =
    LedgerMasterACdata?.Detail?.map((label, index) => ({
      // srNumber: index + 1,
      Date: formatDateToDDMMYYYY(label.Date),
      Type: label.Type,
      VouNo: label.VouNo,
      ChqNo: label.ChqNo,
      AcName: label.AcName,
      Debit: label.Debit,
      Credit: label.Credit,
      Balance: label.Balance,
      AmtType: label.AmtType,
    })) || [];

  const getColumns = [
    // { label: "Chart", key: "chartButton", width: 60 },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Date", key: "Date", align: "center" },
    {
      label: "Type",
      key: "Type",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Vou No", key: "VouNo", align: "right" },
    { label: "Chq No", key: "ChqNo", align: "right" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Debit", key: "Debit", align: "right", format: true },
    { label: "Credit", key: "Credit", align: "right", format: true },
    { label: "Balance", key: "Balance", align: "right", format: true },
    { label: "Amt Type", key: "AmtType", align: "right" },
  ];

  return (
    <div
      style={{
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        paddingTop: "16px",
      }}
    >
      <style>{`
        .common-hover-btn {
          transition: transform 0.25s ease;
        }
        .common-hover-btn:hover {
          transform: scale(1.01);
        }
        .common-hover-btn:active {
          transform: scale(0.98);
        }
      `}</style>
      <Row>
        {/* TABLE */}
        <Col xs={12}>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  margin: 0,
                  padding: "14px",
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  MASTER ACCOUNT
                </h2>
              </div>
              <FASTable data={getRows} columns={getColumns} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
